module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/cartype-639a1ec500be92e8030f18ae7c71d72f.png";